// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CommandButtons__row-cc7b1d {
  display: flex;
  justify-content: space-between;
  margin: 2px 0;
}

.CommandButtons__row-cc7b1d:last-child {
  overflow: hidden;
  border-radius: 0 0 16px 16px;
}

.CommandButtons__my-bubble-button-e931ad {
  --background-color: var(--addition-150);
  --background-color-hover: var(--addition-150);
  --background-color-focus: var(--addition-150);
  --background-color-active: var(--addition-150);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/ButtonsBubble/CommandButtons/CommandButtons.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,aAAA;AACF;;AAEA;EACE,gBAAA;EACA,4BAAA;AACF;;AAEA;EACE,uCAAA;EACA,6CAAA;EACA,6CAAA;EACA,8CAAA;AACF","sourcesContent":[".row {\n  display: flex;\n  justify-content: space-between;\n  margin: 2px 0;\n}\n\n.row:last-child {\n  overflow: hidden;\n  border-radius: 0 0 16px 16px;\n}\n\n.my-bubble-button {\n  --background-color: var(--addition-150);\n  --background-color-hover: var(--addition-150);\n  --background-color-focus: var(--addition-150);\n  --background-color-active: var(--addition-150);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `CommandButtons__row-cc7b1d`,
	"my-bubble-button": `CommandButtons__my-bubble-button-e931ad`,
	"myBubbleButton": `CommandButtons__my-bubble-button-e931ad`
};
module.exports = ___CSS_LOADER_EXPORT___;
